import _ from 'lodash';
import React from 'react';
import { Card, Grid, Heading } from '@mlc/web-ui-toolkit';
import * as Styled from './styled';
import * as palette from '@mlc/mlc-palette';
import quickLinksTestIds from './QuickLinks.elements';
import QuickLinksItem, { QuickLink } from './QuickLinksItem/QuickLinksItem';

interface Props {
	links: QuickLink[];
}

const QuickLinks: React.FunctionComponent<Props> = (props: Props) => {
	const items = props.links.map(link => {
		const key = _.snakeCase(link.name);
		return <QuickLinksItem key={key} {...link} />;
	});

	return (
		<Card
			textAlign="center"
			backgroundColor={palette.mlcKoala}
			paddingTop={9}
			paddingBottom={9}
			data-analytics-group="tools_quickLinks"
		>
			<Grid>
				<Heading el="h2" fontSize="regular" mb="50px" mt="0px">
					Tools &amp; quick links
				</Heading>
				<Styled.Links data-id={quickLinksTestIds.quickLinksContainer}>
					{items}
				</Styled.Links>
			</Grid>
		</Card>
	);
};

export default QuickLinks;
